import React, {
    useContext,
    useEffect,
} from "react"

import Alert from "react-bootstrap/Alert"

import {
    Context, 
    EMETLContext,
} from "../../../Model/Contexts/AppContext"

import EMETLNavButton from "../EMETLNavButton"

import "./style.css"

const EMETLBanner = () => {
    const {
        banner: {
            info,
            setInfo,
            warning,
            setWarning,
            error,
            setError,
        }
    } = useContext(Context) as EMETLContext

    const variant = error ? "danger" : warning ? "warning" : "info"
    const message = error || warning || info

    const dismiss = () => {
        setInfo("")
        setWarning("")
        setError("")
    }

    useEffect(() => {
        if (variant === "info") {
            const timer = setTimeout(() => {
                setInfo("")
            }, 5000)
            return () => clearTimeout(timer)
        }
    }, [info])

    return (
        <Alert 
            key={variant} 
            variant={variant}
            className="emetlBanner"
            show={!!message}
        >
            {message}
            <EMETLNavButton
                onClick={dismiss}
                className="bannerDismissButton"
            >
                Dismiss
            </EMETLNavButton>
        </Alert>
    )
}

export default EMETLBanner